import Promise from 'bluebird';
import _request from 'request';

const request = Promise.promisifyAll(_request);

export default (Topics, settings, handle /* TODO , savePost */) => (userRequest) => {
  // request original-post then wrap and post it
  // return Promise resolve with postData or topicData
  const { url, cid, tid } = userRequest.body;
  const { uid } = userRequest;
  if (!(cid || tid)) {
    return Promise.reject(Error('[[error:missing-place-to-post]]'));
  }
  // console.log(url);
  if (!url || typeof url !== 'string') {
    return Promise.reject(Error('[[error:invalid-url]]'));
  }

  const getInputData = ([res, pluginSettings]) => ({
    raw: res.body,
    settings: pluginSettings,
    info: {
      url,
      uid,
      cid,
      tid,
    },
  });

  const appendUid = args => ({ ...args, uid });

  let savePost;

  // TODO move these two branches into separate modules
  // delegate control to init.js
  if (cid) {
    const appendCid = args => ({ ...args, cid });
    savePost = postData => Promise.resolve(postData)
      .then(appendCid)
      .then(Topics.postAsync)
      .then(data => ({ tid: data.topicData.tid }));
  } else /* if (tid) */ {
    const appendTid = args => ({ ...args, tid });
    savePost = postData => Promise.resolve(postData)
      .then(appendTid)
      .then(Topics.replyAsync)
      .then(data => ({ pid: data.pid }));
  }

  return Promise.all([
    request.getAsync(url),
    settings.getAsync('leech-tool'),
  ]).then(getInputData)
    .then(handle)
    .then(appendUid)
    .then(savePost);
};
